export const html = "<p>One night in a special Armenian heritage hotel.</p>\n";
export const leadHtml = "<p>One night in a special Armenian heritage hotel.</p>\n";
export const bodyHtml = "";
export const metaText = "One night in a special Armenian heritage hotel.";